module.exports = __webpack_public_path__ + "static/media/icon_market_noti.56edf5a5.png";